module.exports = __webpack_public_path__ + "static/img/avatar.4fa0c94f.webp";